// Use only for forward reference - when a warehouse location must be hard-coded for some reason
// The real list of active warehouses is dynamic - not all will be represented here.
const warehouseLocation = {
  Leola102: 102,
  Delaware103: 103,
  BaltimoreAux: 104,
  Hometown: 105,
  Baltimore106: 106,
  Albany107: 107,
  Fernley108: 108,
  Savannah: 109,
  Texas: 110,
  LeolaCDC2: 851,
  Kentucky: 852,
  Reno: 853,
  Oklahoma: 854,
  Maryland: 855,
  Ellabell: 856,
  Sparks: 857,
  Cumberland: 871,
  Albany: 872,
  Dayton: 873,
  Madisonville: 875,
  Bloomsburg: 876,
  SWBath3PL: 980,
} as const;
export default warehouseLocation;
